import { ShiftCategoryInterface } from 'core/interfaces/shiftCategoryInterface';
import { ShiftReasonInterface } from 'core/interfaces/shiftReasonInterface';
import { apiService } from 'core/services/apiService';
import { paginationService } from 'core/services/paginationService';
import { IShiftGetOne, IShiftPayload } from 'module/schedule/interfaces/ShiftsInterface';

export interface IObj {
	shift: number;
	role: number;
}

const PostShifts = async (body: IShiftPayload): Promise<any> => {
	const { ...data } = apiService.responseHandler(await apiService.post(`shifts`, body));

	return data;
};

const EditShifts = async (shiftID: number, body: IShiftPayload): Promise<any> => {
	const { ...data } = apiService.responseHandler(await apiService.put(`shifts/${shiftID}`, body));

	return data;
};

const PostShiftsAddRole = async (obj: IObj): Promise<any> => {
	const { ...data } = apiService.responseHandler(
		await apiService.post(`shifts/${obj.shift}/roles/${obj.role}`)
	);

	return data;
};

const DeleteShiftsAddRole = async (obj: IObj): Promise<any> => {
	const { ...data } = apiService.responseHandler(
		await apiService.delete(`shifts/${obj.shift}/roles/${obj.role}`)
	);

	return data;
};

const DeleteShift = async (shiftID: number): Promise<any> => {
	const { ...data } = apiService.responseHandler(await apiService.delete(`shifts/${shiftID}`));

	return data;
};

const GetOneShift = async (shiftID: number): Promise<IShiftGetOne> => {
	const { ...data } = apiService.responseHandler(await apiService.get(`shifts/${shiftID}`));

	return data;
};

export interface IPutOneShift {
	body: IShiftPayload;
	id: number | null;
}

const PutOneShift = async (value: IPutOneShift): Promise<any> => {
	const { ...data } = apiService.responseHandler(
		await apiService.put(`shifts/${value.id}`, {
			...value.body,
		})
	);

	return data;
};

export interface ShiftId {
	id: number;
}

export interface IPublishShifts {
	shifts: ShiftId[];
}

export interface Workplace {
	"@id": string;
	"@type": "Workplace";
	id: number;
	name: string;
}

export interface ShiftUser {
	"@id": string;
	"@type": "User";
	id: number;
	firstName: string;
	middleName: string;
	lastName: string;
	email: string;
}

export interface JobCode {
	"@id": string;
	"@type": "JobCode";
	id: number;
	label: string;
	backgroundColor: string;
	textColor: string;
	category: any;
	jobNumber: any;
	active: boolean;
	deleted: boolean;
	created_at: string | null;
	updated_at: string | null;
}

export interface Shift {
	"@id": string;
	"@type": "Shift";
	id: number;
	workplace: Workplace;
	startAt: string;
	endAt: string;
	employee: ShiftUser | null;
	jobCode: JobCode | null;
	createdBy: ShiftUser;
	published: boolean;
	publishedAt: string | null;
	publishedBy: ShiftUser | null;
	active: boolean;
	deleted: boolean;
	created_at: string;
	updated_at: string;
}

const PutPublishShifts = async (body: IPublishShifts): Promise<any> => {
	const { ...data } = apiService.responseHandler(await apiService.put(`shifts/publish`, body));

	return data;
};

const GetShiftCategories = async (): Promise<ShiftCategoryInterface> => {
	const { ...data } = apiService.responseHandler(await apiService.get(`shift-category`));

	return data;
};

const GetShiftReasons = async (): Promise<ShiftReasonInterface> => {
	const { ...data } = apiService.responseHandler(await apiService.get(`shift-reasons`));

	return data;
};

interface IFetchAllShifts {
	workplaceId: number;
	fromDate: string;
	toDate: string;
}

const fetchAllShifts = async (params: IFetchAllShifts): Promise<any> => {
	const queryString = `shifts?workplace=${params.workplaceId}&startAt[after]=${params.fromDate}&endAt[before]=${params.toDate}`;
	const data = await paginationService.getWithHandler(queryString, undefined, 100);
	return data;
};

interface IPublishShiftsRange {
	workplace: string;
	start: string;
	end: string;
}

const publishShiftsInRange = async (params: IPublishShiftsRange): Promise<any> => {
	const { ...data } = apiService.responseHandler(
		await apiService.post(`shifts/publish`, params)
	);

	return data;
};

interface ICopyShifts {
	workplace: string;
	source_range: {
		start: string;
		end: string;
	};
	target_start: string;
	options: {
		copy_exact_schedule: boolean;
		copy_to_house_schedule: boolean;
	}[];
}

const copyShifts = async (params: ICopyShifts): Promise<any> => {
	const { ...data } = apiService.responseHandler(
		await apiService.post(`shifts/copy`, params)
	);

	return data;
};

export {
	PostShifts,
	EditShifts,
	PostShiftsAddRole,
	DeleteShift,
	GetOneShift,
	PutOneShift,
	PutPublishShifts,
	DeleteShiftsAddRole,
	GetShiftCategories,
	GetShiftReasons,
	fetchAllShifts,
	publishShiftsInRange,
	copyShifts,
};
